import { styled, useStyledTheme } from '@openeducation/oe-rn-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';

import FeedbackResponse from './feedback-response';
import { Icon, OEButton, OEText } from '../../../atoms';

type FeedbackSuccessProps = {
  onReset: () => void;
  newQuestionKey?: string;
  children: React.ReactNode;
};

export default function FeedbackSuccess({
  onReset,
  newQuestionKey,
  children,
}: FeedbackSuccessProps) {
  const { color } = useStyledTheme();
  const { t } = useTranslation();

  return (
    <FeedbackResponse
      icon={<Icon type="solid" name="check" size={40} color={color.primary} />}
    >
      {children}

      {newQuestionKey && (
        <StyledButton onPress={onReset}>
          <StyledButtonText>{t(newQuestionKey)} »</StyledButtonText>
        </StyledButton>
      )}
    </FeedbackResponse>
  );
}

const StyledButton = styled(OEButton)`
  margin-top: 25px;
  background-color: ${({ theme }) => theme.color.transparent};
`;

const StyledButtonText = styled(OEText)`
  font-size: 16px;
  color: ${({ theme }) => theme.color.accent};
  background-color: ${({ theme }) => theme.color.transparent};
`;
